import { linklistApi } from '@/utils/axios-config';
import router from '../router';

export default {
    login(email, password) {
        return linklistApi.post(`/auth/login/`, {
            email,
            password,
        });
    },
    async logout() {
        await linklistApi.get(`/auth/logout`);
        router.push({ path: '/admin/login?logout' });
    },
    refresh(token, issued_at, expires_at) {
        return linklistApi.get(`/auth/refresh`);
    },
};
